import flatpickr from "flatpickr";
const dateFields = (fields, options = {}) => {
  fields.forEach(field => {
    if (!field) return;
    let config = Object.assign(
      options,
      JSON.parse(field.dataset.dateConfig || '{"default":"today"}')
    );
    
    // hightlighted date ranges
    let highlighted = (config.highlightDates||[]).map(d => {
      return (
        typeof d === 'object' &&
        !Array.isArray(d) &&
        d !== null
      ) ? [
        new Date(d.from), new Date(d.to)
      ] : [
        new Date(d), new Date(d)
      ];
    });

    const highlightDates = highlighted.length > 0 ? (dObj, dStr, fp, d) => {
      highlighted.forEach(range => {
        range[0].setHours(0,0,0);
        range[1].setHours(23,59,59);
        let hit = d.dateObj >= range[0] && d.dateObj <= range[1];
        d.className += hit ? " flatpickr-highlighted-day" : " flatpickr-de-highlighted-day";
      });
    } : () => {};
    
    // boot flatpickr
    flatpickr(field, {
      mode: config.mode ? config.mode : "single",
      showMonths: config.showMonths && document.body.clientWidth > 800 ? config.showMonths : 1,
      minDate: "today",
      dateFormat: "d M y",
      defaultDate: config.default,
      position: config.position ? config.position : 'auto',
      enable: config.enable ? config.enable.map(d => {
        return (
          typeof d === 'object' &&
          !Array.isArray(d) &&
          d !== null
        ) ? [
          new Date(d.from), new Date(d.to)
        ] : new Date(d);
      }) : [() => true],
      onDayCreate: highlightDates,
      onClose: config.change ? config.change : ()=>{},
      onReady: config.ready ? config.ready : ()=>{},
    });
  });
}
export { dateFields };


// WEBPACK FOOTER //
// ./source/scripts/products/lib/ui.js